module.exports = __webpack_public_path__ + "img/sword-bronze.5f1c62a3.svg";